// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2-UYA","title":"ClientInsurance_title__3Lr0Q","itemText":"ClientInsurance_itemText__qb5Pj"};